import { z } from 'zod';

// Schemas for the ai_per_record_enrichment_queue table and its associated
// NOTIFY payload. The queue table drives the per-record AI cadence for
// forms and playtests: one row per feedback_pool record that needs the
// embedding / Haiku classification / aspect extraction passes, worked by
// the bot's per-record queue worker rather than synchronously on the
// feedback_ingested listener.

// --- Enums ------------------------------------------------------------------

export const AiPerRecordEnrichmentQueueStatusSchema = z.enum([
  'pending',
  'claimed',
  'done',
  'dead',
]);
export type AiPerRecordEnrichmentQueueStatus = z.infer<
  typeof AiPerRecordEnrichmentQueueStatusSchema
>;

// --- NOTIFY payload ---------------------------------------------------------

// Matches the JSON emitted by migration 0073's
// notify_ai_per_record_enrichment_queued trigger.
export const AiPerRecordEnrichmentQueuedPayloadSchema = z.object({
  queueRowId: z.string().uuid(),
  feedbackId: z.string().uuid(),
  studioId: z.string().uuid(),
  gameId: z.string().uuid(),
});
export type AiPerRecordEnrichmentQueuedPayload = z.infer<
  typeof AiPerRecordEnrichmentQueuedPayloadSchema
>;

// --- Row schema -------------------------------------------------------------

// Camel-case row schema covering every column on the queue table.
// Worker-produced fields (claimed_at, done_at, last_error) are nullable
// until the worker touches the row.
export const AiPerRecordEnrichmentQueueRowSchema = z.object({
  id: z.string().uuid(),
  feedbackId: z.string().uuid(),
  studioId: z.string().uuid(),
  gameId: z.string().uuid(),
  status: AiPerRecordEnrichmentQueueStatusSchema,
  attemptCount: z.number().int().nonnegative(),
  claimedAt: z.string().datetime({ offset: true }).nullable(),
  nextAttemptAt: z.string().datetime({ offset: true }),
  lastError: z.string().nullable(),
  doneAt: z.string().datetime({ offset: true }).nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type AiPerRecordEnrichmentQueueRow = z.infer<
  typeof AiPerRecordEnrichmentQueueRowSchema
>;
